<template>
  <section>
    <header>
      <div class="header-info">
        <h2>Aprovar Vouchers</h2>
      </div>
      <div class="header-actions" v-if="approveVoucher">
        <div class="select-all-wrap" v-if="vouchers.length > 0">
          <label class="check-control large">
            <input type="checkbox" class="check" v-model="allSelected" @change="toggleSelectAll">
            <span>Selecionar Todos</span>
          </label>
        </div>
        <a href="#" 
          class="btn btn-success-2" 
          :class="{ 'disabled': selectedVouchers.length === 0 }"
          @click.prevent="approveSelected"
        >
          &nbsp;Aprovar ({{ selectedVouchers.length }})
        </a>
        <a href="#"  
          class="btn btn-primary" 
          :class="{ 'disabled': selectedVouchers.length === 0 }"
          @click.prevent="approveSelected"
        >
          &nbsp;Reprovar ({{ selectedVouchers.length }})
        </a>
      </div>
    </header>
    <div class="voucher-grid" v-if="vouchers.length > 0">
      <div 
        v-for="voucher in vouchers"
        :key="voucher.idTipoVoucher" 
        :class="['tipoVoucherCard']"
        @click="toggleSelection(voucher.idTipoVoucher)"
      >
        <div>
          <div class="card-header">
            <div class="icon-box">
              {{ voucher.quantidade }}
              <!-- <fa :icon="voucher.icon" /> -->
            </div>
            <label class="check-control">
              <input type="checkbox" class="check invert" :value="voucher.idTipoVoucher" v-model="selectedVouchers">
            </label>
          </div>

          <div class="card-body">
            <h4 class="voucher-title">{{ voucher.tipo }}</h4>
            <!-- <span class="voucher-requester">Sol.: {{ voucher.requester }}</span> -->
          </div>

          <div class="card-footer">
            <span class="voucher-value">{{ voucher.total_valor ? formatMoney(voucher.total_valor) : '-' }}</span>
            <!-- <span class="voucher-date">{{ voucher.date }}</span> -->
          </div>
        </div>
      </div>
    </div>

    <div v-else class="empty-state">
      <fa :icon="['fal', 'circle-check']" class="ic" />
      <h1>Tudo certo!</h1>
      <p>Não há vouchers pendentes para aprovação.</p>
    </div>

  </section>
</template>

<script>
import FinanceiroService from '@/services/financeiro.service.js'
import UserService from '@/services/user.service.js'
import { formatMoney } from '@/services/utils.service.js';

export default {
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      selectedVouchers: [],
      approveVoucher: false,
      vouchers: [
        // { id: 101, title: 'Uber Viagem', requester: 'João Silva', value: 45.90, date: '28/11', type: 'transporte' },
        // { id: 102, title: 'Almoço Equipe', requester: 'Maria Souza', value: 250.00, date: '27/11', type: 'alimentacao' },
        // { id: 103, title: 'Material Escritório', requester: 'RH', value: 120.50, date: '26/11', type: 'infra' },
        // { id: 104, title: 'Hospedagem SP', requester: 'Carlos Lima', value: 890.00, date: '25/11', type: 'viagem' },
        // { id: 105, title: 'Assinatura Adobe', requester: 'Marketing', value: 240.00, date: '28/11', type: 'software' },
      ]
    }
  },
  computed: {
    allSelected: {
      get() {
        return this.vouchers.length > 0 && this.selectedVouchers.length === this.vouchers.length
      },
    //   set(value) {
    //   }
    }
  },
  mounted () {
    console.log("Módulo de aprovação iniciado para ID:", this.id)
    this.approveVoucher = UserService.filterPermissions('approveVoucher')

    if ( !this.approveVoucher ) {
      this.$router.push({name:'Vouchers'})
      return false
    }
    this.getVouchersAprovacao()
  },
  methods: {
    getVouchersAprovacao () {
      FinanceiroService.getVouchersAprovacao().then(
        response => {
          if ( response.data.length > 0 ) {
            this.vouchers = response.data
          }
          console.log("getVouchersAprovacao", response.data)
        }
      ).catch(
        error => {
          console.error(error)
        }
      )
    },
    toggleSelectAll() {
      if (this.allSelected) {
        this.selectedVouchers = []
      } else {
        this.selectedVouchers = this.vouchers.map(v => v.idTipoVoucher)
      }
    },
    toggleSelection(id) {
      if (this.selectedVouchers.includes(id)) {
        this.selectedVouchers = this.selectedVouchers.filter(vId => vId !== id)
      } else {
        this.selectedVouchers.push(id)
      }
    },
    approveSelected() {
      if (this.selectedVouchers.length === 0) return
      console.log("this.selectedVouchers:", this.selectedVouchers)
      const payload = {
        idsTipoVoucher: Object.assign([],this.selectedVouchers),
        idsVouchers: []
      }
      window.spinner.emit('open')
      FinanceiroService.aprovarVouchers( payload ).then(
        response => {
          window.toaster.emit('open', { style: 'success', message: 'Vouchers aprovados com sucesso.', floater: true })
          console.log("aprovarVoucher:", response.data)
          this.getVouchersAprovacao()
        }
      ).catch(
        error => {
          window.toaster.emit('open', { style: 'error', message: 'Ops! Algo Aconteceu. Não foi possível aprovar os vouchers selecionados. ' + error, floater: true })
        }
      ).finally(() => {
        window.spinner.emit('close')
      })
      
    },
    formatMoney(value) {
      return formatMoney(value)
    },
  }
}
</script>

<style lang="scss" scoped>

header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: $hmg_mid;
  border-bottom: $border-component;

  h2 {
    margin: 0;
    font-size: 24px;
  }
  .subtitle {
    margin: 5px 0 0 0;
    color: $color-text;
    font-size: 14px;
  }
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 20px;

  .select-all-wrap {
    display: flex;
    align-items: center;
    
    label {
      cursor: pointer;
      font-weight: 600;
      color: $color-text;
    }
  }
}

.voucher-grid {
  padding: $hmg_mid;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 25px;
}

.tipoVoucherCard {
  border-radius: $border-radius;
  border: $border-component;
  background-color: $color-secondary;
  overflow: hidden;
  @extend %transition_6o;
  cursor: default;

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: $color-secondary;
    padding: $mg_mini;
    line-height: 1;
  }
  .card-footer {
    display: flex;
    justify-content: space-between;
    padding: $mg_mini;
    background-color: $color-secondary;
  }

  &:hover {
    box-shadow: 1px 6px 32px rgba(0,0,0,0.1);
  }
}

.empty-state {
  max-width: 440px;
  margin: $mg_large auto 0;
  padding: $mg; border-radius: $border-radius;
  border: $border-component;
  text-align: center;
  
  .ic {
    font-size: 64px;
    margin-bottom: $mg_mid;
    color: $color-success-2;
  }
}
// .tipoVoucherCard {
//   background-color: #fff;
//   border-radius: 8px;
//   padding: 20px;
//   position: relative;
//   cursor: pointer;
//   transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
//   border: 1px solid transparent;
  
//   box-shadow: 0 3px 14px rgba(0,0,0,0.05);

//   &:hover {
//     transform: translateY(-5px);
//     box-shadow: 0 10px 25px rgba(0,0,0,0.1);
//   }

//   &::after {
//     content: '';
//     position: absolute;
//     top: 0; left: 0; right: 0; bottom: 0;
//     border-radius: 8px;
//     border: 2px solid transparent;
//     transition: 0.2s;
//     pointer-events: none;
//   }
  
//   &:has(input:checked), &.selected {
//     &::after {
//       border-color: $color-primary;
//     }
//   }

//   .card-top {
//     display: flex;
//     justify-content: space-between;
//     align-items: flex-start;
//     margin-bottom: 15px;
//   }

//   .icon-box {
//     width: 45px;
//     height: 45px;
//     border-radius: 12px;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     font-size: 18px;
//     color: #fff;
//   }

//   .card-body {
//     margin-bottom: 15px;
    
//     .voucher-title {
//       font-size: 16px;
//       font-weight: 700;
//       color: #474a4f;
//       margin: 0 0 5px 0;
//       line-height: 1.2;
//     }
    
//     .voucher-requester {
//       font-size: 12px;
//       color: $color-text;
//     }
//   }

//   .card-footer {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     padding-top: 15px;
//     border-top: 1px dashed #e3e3e9;

//     .voucher-value {
//       font-weight: 700;
//       font-size: 15px;
//       color: #474a4f;
//     }

//     .voucher-date {
//       font-size: 11px;
//       font-weight: 600;
//       padding: 2px 8px;
//       border-radius: 10px;
//       background-color: #f0f0f5;
//       color: $color-text;
//     }
//   }
// }

// .theme-azul {
//   background-color: rgba($theme-azul, 0.08);
//   .icon-box { background-color: $theme-azul; box-shadow: 2px 6px 16px rgba($theme-azul, 0.4); }
// }
// .theme-verde {
//   background-color: rgba($theme-verde, 0.08);
//   .icon-box { background-color: $theme-verde; box-shadow: 2px 6px 16px rgba($theme-verde, 0.4); }
// }
// .theme-laranja {
//   background-color: rgba($theme-laranja, 0.08);
//   .icon-box { background-color: $theme-laranja; box-shadow: 2px 6px 16px rgba($theme-laranja, 0.4); }
// }
// .theme-roxo {
//   background-color: rgba($theme-roxo, 0.08);
//   .icon-box { background-color: $theme-roxo; box-shadow: 2px 6px 16px rgba($theme-roxo, 0.4); }
// }
// .theme-rosa {
//   background-color: rgba($theme-rosa, 0.08);
//   .icon-box { background-color: $theme-rosa; box-shadow: 2px 6px 16px rgba($theme-rosa, 0.4); }
// }
// .theme-padrao {
//   background-color: #fff;
//   .icon-box { background-color: $color-text; }
// }

// .empty-state {
//   text-align: center;
//   padding: 80px 0;
//   color: $color-text;
  
//   .empty-icon {
//     font-size: 60px;
//     margin-bottom: 20px;
//     color: #e3e3e9;
//   }
// }


</style>